import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, Tooltip, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";
import { airportlist } from "./date";
import { fetchallFd, fetchactiveFd, addFd, fetchFdbyId, fetchFdbyDest, updateFd} from "../api/customerapi";
import { useAppData } from "./appDataContext.js";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(40),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Fd = () => {

    const classes = useStyles();
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    var {cuser, role}=GetRole();
    const { appData, loading } = useAppData();
    const [fdData, setfdData] =useState({
      name:"",
      journey_type:"",
      supplier_name:"",
      source_airport:"",
      destination_airport:"",
      date_record:[],
      expiry:"",
    });
   

    const getFdId = async (currentid) => {
        try{
        const data = await fetchFdbyId(Number(currentid));
        console.log(data.data)
        setfdData(data.data)
    }catch(err){
        console.log(err)
      }
    }



    const addsp = () => {
      //console.log(spdata)
  
      setfdData({...fdData, date_record:[...fdData.date_record, {reach_day:"",
        start_date:"2025-01-01",
        price:0,
        seats:0,}]});
    };
  
    const removesp = () => {
      //console.log(spdata)
      setfdData({...fdData, date_record:[...fdData.date_record.slice(0,fdData.date_record.length-1)]});
    };

    useEffect(() => {
        
      getFdId(currentid)
        
        
    }, [])

    //console.log(dest);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        
        const updatefdResponse= await updateFd(fdData._id, fdData);
        
        if(updatefdResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for FD with fd id "+updatefdResponse.data.fd_id);
            window.location = ("/fddataentry/"+updatefdResponse.data.fd_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }  
    }catch(err){
        console.log(err)
      }     
    }

    return ( 
      <Paper variant="outlined" className={classes.paper} elevation={10}>
      <Typography variant="h4" align="center" className={classes.headertext}> Update FD</Typography>
      <form onSubmit={handleSubmit}>
      
      <FormGroup row className={classes.formgroup}>
          <TextField variant="standard"  disabled={role=="Product" || role=="Admin"?0:1} required label="Name"  value={fdData.name}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setfdData({...fdData, name: e.target.value})}/>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
          <InputLabel id="JT">Journey Type</InputLabel>
          <Select displayEmpty disabled={role=="Product" || role=="Admin"?0:1} className={classes.textField} labelId="JT" value={fdData.journey_type} onChange={(e)=> setfdData({...fdData, journey_type: e.target.value})}>
         
          <MenuItem value={"Onward"}>Onward</MenuItem>
          <MenuItem value={"Return"}>Return</MenuItem>
          </Select>
          </FormControl>
          <TextField variant="standard"  disabled={role=="Product" || role=="Admin"?0:1} label="Supplier"  value={fdData.supplier_name}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setfdData({...fdData, supplier_name: e.target.value})}/>
      </FormGroup>
          <FormGroup row className={classes.formgroup}>
         
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
          <InputLabel id="SourceAirport">Source Airport</InputLabel>
          <Select displayEmpty disabled={role=="Product" || role=="Admin"?0:1} className={classes.textField} labelId="SourceAirport" value={fdData.source_airport} onChange={(e)=> setfdData({...fdData, source_airport: e.target.value})}>
         
          {airportlist.map(emp => {
              return <MenuItem value={emp.airport}>{emp.airport}</MenuItem>})}
          </Select>
          </FormControl>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
          <InputLabel id="DestAirport">Destination Airport</InputLabel>
          <Select displayEmpty disabled={role=="Product" || role=="Admin"?0:1} className={classes.textField} labelId="DestAirport" value={fdData.destination_airport} onChange={(e)=> setfdData({...fdData, destination_airport: e.target.value})}>
          {airportlist.map(emp => {
              return <MenuItem value={emp.airport}>{emp.airport}</MenuItem>})}
              
          </Select>
          </FormControl>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
          <InputLabel id="expiry">Expired?</InputLabel>
          <Select displayEmpty disabled={role=="Product" || role=="Admin"?0:1} className={classes.textField} labelId="expiry" value={fdData.expiry} onChange={(e)=> setfdData({...fdData, expiry: e.target.value})}>
         
          <MenuItem value={"Yes"}>Yes</MenuItem>
          <MenuItem value={"No"}>No</MenuItem>
          </Select>
          </FormControl>
          <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
                <InputLabel id="duration">Duration</InputLabel>
                <Select displayEmpty disabled={role=="Product" || role=="Admin"?0:1} className={classes.textField} labelId="duration" value={fdData.duration} onChange={(e)=> setfdData({...fdData, duration: e.target.value})}>
                <MenuItem value={"3"}>3</MenuItem>
                <MenuItem value={"4"}>4</MenuItem>
                <MenuItem value={"5"}>5</MenuItem>
                <MenuItem value={"6"}>6</MenuItem>
                <MenuItem value={"7"}>7</MenuItem>  
                </Select>
                </FormControl>
          
      </FormGroup>


      <FormGroup row className={classes.formgroup}>
      <Tooltip title="Destination Start Date and Time - Stop End Date and Time || Halt time || Next Leg">
      <TextField variant="outlined"  disabled={role=="Product" || role=="Admin"?0:1} label="Onward FLight Details"  InputLabelProps={{ shrink: true }} value={fdData.onward_flight} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> setfdData({...fdData, onward_flight: e.target.value})}/>
      </Tooltip>
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
          <Tooltip title="Destination Start Date and Time - Stop End Date and Time || Halt time || Next Leg">
      <TextField variant="outlined" disabled={role=="Product" || role=="Admin"?0:1} label="Return FLight Details"  InputLabelProps={{ shrink: true }} value={fdData.return_flight} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> setfdData({...fdData, return_flight: e.target.value})}/>
      </Tooltip>
          </FormGroup>

          <FormGroup row className={classes.formgroup}>
          {fdData && fdData.date_record.map((item) => {
      return (
        <div id="fddates">
          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="standard"
              label="Start date"
              type="date"
              disabled={role=="Product" || role=="Admin"?0:1}
              InputLabelProps={{ shrink: true }}
              value={
                item.start_date.split("T").slice(0,1)
              }
              className={classes.textField}
              onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,start_date:e.target.value}:f)})}
            />
            <TextField
              variant="standard"
              label="Price"
              disabled={role=="Product" || role=="Admin"?0:1}
              // name={fdData.date_record.indexOf(item)}
              value={
                item.price
              }
              className={classes.textField}
              onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,price:e.target.value}:f)})}
            />
            <TextField
              variant="standard"
              label="Seats"
              disabled={role=="Product" || role=="Admin"?0:1}
              // name={fdData.date_record.indexOf(item)}
              value={
                item.seats
              }
              className={classes.textField}
              onChange={(e) => setfdData({...fdData, date_record: fdData.date_record.map(f=>fdData.date_record.indexOf(item)==fdData.date_record.indexOf(f)?{...f,seats:e.target.value}:f)})}
            />
            
          </FormGroup>
          {fdData.date_record.length>0 && fdData.date_record.indexOf(item)==fdData.date_record.length-1?(
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addsp()}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removesp(item)}
            >
              {" "}
              - Tranche
            </Button>
            </FormGroup>
                ):("")}
        </div>
      );
    })}
      </FormGroup>
      {fdData.date_record.length==0?(
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addsp()}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removesp()}
            >
              {" "}
              - Tranche
            </Button>
            </FormGroup>
            ):("")}
            {role=="Product" || role=="Admin"?(
      <FormGroup row className={classes.formgroup}>
          <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
          <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
      </FormGroup>
    ):("")}
      </form>
  </Paper>
     );
}

export default Fd;